export const i18nAdvertisement = (advertisement, language) => {
  if (!advertisement) {
    return null
  }

  let lng = advertisement.public_title[language] ? language : advertisement.fallback_language

  if (!advertisement.public_title[lng]) {
    lng = Object.keys(advertisement.public_title)[0]
  }

  return {
    title: advertisement.public_title[lng],
    content: advertisement.content[lng],
    signature: advertisement.signature && advertisement.signature[lng],
    image: advertisement.image
  }
}
